// extracted by mini-css-extract-plugin
export default {"doctorCard":"DoctorDetail_doctorCard__aSk7X","pageTitle":"DoctorDetail_pageTitle__ZxFI1","titleText":"DoctorDetail_titleText__n1KWL","titleLogo":"DoctorDetail_titleLogo__AWzW8"};